import { locale } from "../locale/index";

const showConfirm = function (
  tip: string = locale("perform_this_action"),
  confirmButtonText: string = locale("determine"),
  cancelButtonText: string = locale("cancel")
) {
  return this.$confirm(tip, locale("tips"), {
    confirmButtonText,
    cancelButtonText,
    type: "warning",
  });
};
export default showConfirm;
